module.exports = __webpack_public_path__ + "img/twitter-white.0a371161.svg";